import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './try-again.styles';
import SomethingWentWrongIcon from '@stencil/flights-icons/src/something-went-wrong-icon';

const TryAgain = props => {
  const { isDweb = false } = props;
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <C.Wrap isDweb={isDweb}>
      <C.CommonDetails>
        <SomethingWentWrongIcon width={'100%'} />
        <S.RetryButton onClick={reloadPage}>Try Again</S.RetryButton>
      </C.CommonDetails>
    </C.Wrap>
  );
};

export default TryAgain;
